/**
 * Slider Component
 *
 * @file slider.js
 */

import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel]);

import 'swiper/swiper-bundle.css';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    const fullSlider = new Swiper('.home-full-slide', {
      loop:true,
      autoplay: {
        delay: 10000,
      },
      pagination: {
        el: '.home-swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.h-next',
        prevEl: '.h-prev',
      },
    });
  };

  const mobileKSlide = () => {
    if(window.innerWidth <= 1170){
      const mobileKSlide = new Swiper('.home-spt-nav .listing', {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
          el: '.home-spt-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.h-spt-next',
          prevEl: '.h-spt-prev',
        },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            spaceBetween: 15,
          },
          680: {
            slidesPerView: 2.6,
            spaceBetween: 15,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });
    }
  };

  const mobilePTabSlide = () => {
    if(window.innerWidth <= 992){
      const mobilePTabSlide = new Swiper('.home-product-list .h-product-tab', {
        slidesPerView: 2.5,
        pagination: {
            clickable: true,
        },
      });
      document.querySelectorAll('.home-product-list .swiper-slide').forEach((slide, index) => {
        slide.addEventListener('click', () => {
          mobilePTabSlide.slideTo(index, 500); // Slide to the clicked slide with a 500ms transition
        });
      });
    }
  };

  const hProductSlide = () => {
    document.addEventListener("DOMContentLoaded", function() {
      var tabItems = document.querySelectorAll(".h-product-tab .item");
      var tabContents = document.querySelectorAll(".h-product-tab-content .tab-content");
  
      var swipers = [];
  
      const slideItems = [
          '.h-slide-item1',
          '.h-slide-item2',
          '.h-slide-item3',
          '.h-slide-item4',
          '.h-slide-item5',
          '.h-slide-item6'
      ];
  
      slideItems.forEach((selector) => {
          if (document.querySelector(selector)) {
              swipers.push(new Swiper(selector, {
                  slidesPerView: 3,
                  spaceBetween: 30,
                  pagination: {
                      el: `${selector} .h-slide-pagination`,
                      clickable: true,
                  },
                  navigation: {
                      nextEl: `${selector} .h-tab-next`,
                      prevEl: `${selector} .h-tab-prev`,
                  },
                  breakpoints: {
                    0: {
                      slidesPerView: 1.2,
                      spaceBetween: 15,
                    },
                    680: {
                      slidesPerView: 2.2,
                      spaceBetween: 15,
                    },
                    992: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                  },
              }));
          }
      });
  
      tabItems.forEach(function(item, index) {
          item.addEventListener("click", function() {
            event.preventDefault();
              tabItems.forEach(function(tabItem) {
                  tabItem.classList.remove("active");
              });
              this.classList.add("active");
  
              tabContents.forEach(function(tabContent) {
                  tabContent.classList.remove("tab-active");
              });
              tabContents[index].classList.add("tab-active");
              swipers.forEach(function(swiper) {
                  swiper.update();
              });
          });
      });
    });
  }

  const init = () => {
    fullSlider();
    mobileKSlide();
    mobilePTabSlide();
    hProductSlide();
  };

  return {
    init,
  };
})();

export default slider;
